<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="입력" icon="pi pi-pencil" class="p-button-success mr-2" @click="btnAct('NEW')" />
            <!-- <Button label="삭제" icon="pi pi-trash" class="p-button-danger  m-2" @click="btnAct('DELETE1')" :disabled="!programAuthList || !programAuthList.length" /> -->
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="compSeq" v-model="searchParams.compSeq" :options ="compCodes" optionLabel="codeNm" optionValue="code" required="true" :showClear="true" style="width: 11rem"/>
                        <label for="compSeq">센터명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="moduleType" v-model="searchParams.moduleType" :options ="moduleTypes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                        <label for="moduleType">업무구분</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="pgmNm" type="text" v-model="searchParams.pgmNm" @keydown.enter="btnAct('SEARCH')"/>
                        <label for="pgmNm">프로그램명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="useYn" v-model="searchParams.useYn" :options ="yns" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                        <label for="useYn">사용여부</label>
                    </div>
                </div> 
            </template>

            <template #end>
                
            </template>
        </Toolbar>
        
        <Splitter style="height: 75vh" layout="vertical">
            <SplitterPanel  :size="50">
                <DataTable id="dt1" ref="dt1" :value="programList" dataKey="pgmSeq" class="editable-cells-table p-datatable-sm" 
                    selectionMode="single" :metaKeySelection="false" v-model:selection="selectedProgram" 
                    editMode="row" v-model:editingRows="editingRows" rowIndexVar="rowIndex" removableSort 
                    @rowEditInit="onRowEditInit"  @rowEditCancel="onRowEditCancel" @rowEditSave="onRowEditSave"
                    @rowSelect="onRowSelect" @rowUnselect="onRowUnselect"
                    :scrollable="true" scrollHeight="350px" responsiveLayout="scroll">
                    <Column field="pgmId" header="*프로그램ID" style="min-width:10em; max-width:10em" :sortable="true" headerClass="required-field">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="20" style="min-width:9em; max-width:9em"/>
                        </template>
                    </Column>
                    <Column field="pgmNm" header="*프로그램명" style="min-width:12em; max-width:12em" :sortable="true" headerClass="required-field">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="50" style="min-width:11em; max-width:11em"/>
                        </template>
                    </Column>
                    <Column field="pgmDesc" header="프로그램설명" style="min-width:12em; max-width:12em">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="100" style="min-width:11em; max-width:11em"/>
                        </template>
                    </Column>
                    <!-- <Column field="pgmPath" header="프로그램명경로" :sortable="true"></Column> -->
                    <Column field="moduleType" header="모듈구분" :sortable="true" style="min-width:10em; max-width:10em">
                        <template #body="{data}">
                            {{(moduleTypes.find(e=>e.code == data.moduleType)||{codeNm:""})['codeNm']}}
                        </template>
                        <template #editor="{ data, field }">
                            <Dropdown v-model="data[field]" :options="moduleTypes" optionLabel="codeNm" optionValue="code" style="min-width:9em; max-width:9em"/>
                        </template>
                    </Column>
                    <Column field="useYn" header="사용" :sortable="false" style="min-width:5em; max-width:5em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true" />
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="useYn" :value="data.useYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="newYn" header="신규" :sortable="false" style="min-width:5em; max-width:5em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true"/>
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="newYn" :value="data.newYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="retrieveYn" header="조회" :sortable="false" style="min-width:5em; max-width:5em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true"/>
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="retrieveYn" :value="data.retrieveYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="saveYn" header="저장" :sortable="false" style="min-width:5em; max-width:5em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true" />
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="saveYn" :value="data.saveYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="saveasYn" header="복사" :sortable="false" style="min-width:5em; max-width:5em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true"/>
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="saveasYn" :value="data.saveasYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="cutYn" header="행삭제" :sortable="false" style="min-width:5em; max-width:5em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true"/>
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="cutYn" :value="data.cutYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="delYn" header="삭제" :sortable="false" style="min-width:5em; max-width:5em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true"/>
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="delYn" :value="data.delYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="excelYn" header="엑셀" :sortable="false" style="min-width:5em; max-width:5em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true"/>
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="excelYn" :value="data.excelYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="eachCompYn" header="센터별제한" :sortable="false" style="min-width:7em; max-width:7em">
                        <template #body="{data, field}">
                            <Checkbox v-model="data[field]" :binary="true" :readonly="true" :disabled="true"/>
                        </template>
                        <template #editor="{ data, field }">
                            <Checkbox :inputId="data.authSerl" name="eachCompYn" :value="data.eachCompYn" v-model="data[field]" :binary="true"/>
                        </template>
                    </Column>
                    <Column field="remark" header="비고" style="min-width:8em; max-width:8em">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="20" style="min-width:7em; max-width:7em"/>
                        </template>
                    </Column>
                    <Column :rowEditor="true" style="max-width: 5rem;" bodyStyle="text-align: center" />
                    <Column :exportable="false">
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct('DELETE',slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>
            </SplitterPanel>    

            <SplitterPanel  :size="50">
                <TabView class="tabview-custom tb-pr-st" ref="tabview4">
                    <TabPanel>
                        <template #header headerClass="name">
                            <i class="pi pi-calendar"></i>
                            <span>사용자구분별 권한</span>
                        </template>
                        <DataTable :value="programAuthList" dataKey="authSerl" :scrollable="true" scrollHeight="400px" 
                            selectionMode="single" :metaKeySelection="false" 
                            editMode="cell" v-model:editingRows="editingRows1" 
                            responsiveLayout="scroll" class="editable-cells-table p-datatable-sm" 
                            @contextmenu="onUserRightClick" aria-haspopup="true">
                            <Column field="userSeq" header="사용자유형" :sortable="true" style="min-width:10rem">
                                <template #body="{data}">
                                    {{(userTypeCodes.find(e=>e.code == data.userSeq)||{codeNm:""})['codeNm']}}
                                </template>
                                <template #editor="{ data }">
                                    <Dropdown id="userSeq" v-model="data.userSeq" :options ="userTypeCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                                </template>
                            </Column>
                            <Column field="useYn" header="사용">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox1(data, field)" />
                                </template>
                            </Column>
                            <Column field="newYn" header="신규">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox1(data, field)" />
                                </template>
                            </Column>
                            <Column field="retrieveYn" header="조회">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox1(data, field)" />
                                </template>
                            </Column>
                            <Column field="saveYn" header="저장">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox1(data, field)" />
                                </template>
                            </Column>
                            <Column field="saveasYn" header="복사">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox1(data, field)" />
                                </template>
                            </Column>
                            <Column field="cutYn" header="행삭제">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox1(data, field)" />
                                </template>
                            </Column>
                            <Column field="delYn" header="삭제">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox1(data, field)" />
                                </template>
                            </Column>
                            <Column field="excelYn" header="엑셀">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox1(data, field)" />
                                </template>
                            </Column>
                        </DataTable>

                        <ContextMenu ref="menu" :model="items" />
                    </TabPanel>
                    <TabPanel>
                        <template #header>
                            <i class="pi pi-cog"></i>
                            <span>센터별 권한</span>
                        </template>
                        <DataTable :value="programAuthList2" dataKey="authSerl" :scrollable="true" scrollHeight="400px"
                            selectionMode="multiple" :metaKeySelection="false" 
                            editMode="cell" class="editable-cells-table p-datatable-sm" 
                            v-model:editingRows="editingRows2"  responsiveLayout="scroll">
                            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                            <Column field="compSeq" header="센터구분" :sortable="true">
                                <template #body="{data}">
                                    {{(compCodes.find(e=>e.code == data.compSeq)||{codeNm:""})['codeNm']}}
                                </template>
                            </Column>
                            <Column field="useYn" header="사용">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox2(data, field)" />
                                </template>
                            </Column>
                            <Column field="newYn" header="신규">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox2(data, field)" />
                                </template>
                            </Column>
                            <Column field="retrieveYn" header="조회">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox2(data, field)" />
                                </template>
                            </Column>
                            <Column field="saveYn" header="저장">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox2(data, field)" />
                                </template>
                            </Column>
                            <Column field="saveasYn" header="복사">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox2(data, field)" />
                                </template>
                            </Column>
                            <Column field="cutYn" header="행삭제">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox2(data, field)" />
                                </template>
                            </Column>
                            <Column field="delYn" header="삭제">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox2(data, field)" />
                                </template>
                            </Column>
                            <Column field="excelYn" header="엑셀">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox2(data, field)" />
                                </template>
                            </Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel>
                        <template #header>
                            <i class="pi pi-cog"></i>
                            <span>사용자 버튼</span>
                        </template>
                        <DataTable :value="programAuthList3" dataKey="authSerl" :scrollable="true" scrollHeight="400px"                            
                             responsiveLayout="scroll">
                            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                            <Column field="buttonId" header="버튼ID" />
                            <Column field="buttonNm" header="버튼명" />
                            <Column field="buttonGbn" header="처리유형" />
                            <Column field="authYn" header="권한여부" />
                            <Column field="useYn" header="사용여부" />
                            <Column field="sortOrd" header="정렬순서" />
                            <Column field="eachAuthYn" header="버튼별제한" />
                            <Column field="remark" header="비고" />
                        </DataTable>
                    </TabPanel>
                    <TabPanel>
                        <template #header>
                            <i class="pi pi-cog"></i>
                            <span>사용자별 권한(-)</span>
                        </template>
                        <DataTable :value="programAuthList4" dataKey="authSerl" :scrollable="true" scrollHeight="400px"
                            selectionMode="multiple" :metaKeySelection="false"  responsiveLayout="scroll">
                            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                            <Column field="userSeq" header="사용자Seq" :sortable="true"></Column>
                            <Column field="useYn" header="사용">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="useYn" :value="data.useYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="newYn" header="신규">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="newYn" :value="data.newYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="retrieveYn" header="조회">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="retrieveYn" :value="data.retrieveYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="saveYn" header="저장">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="saveYn" :value="data.saveYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="saveasYn" header="복사">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="saveasYn" :value="data.saveasYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="cutYn" header="행삭제">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="cutYn" :value="data.cutYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="delYn" header="삭제">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="delYn" :value="data.delYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="printYn" header="출력">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="printYn" :value="data.printYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="excelYn" header="엑셀">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="excelYn" :value="data.excelYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="allYn" header="전체">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="allYn" :value="data.allYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="excludeYn" header="권한제외">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="excludeYn" :value="data.excludeYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>                            
                        </DataTable>
                    </TabPanel>
                    <TabPanel>
                        <template #header>
                            <i class="pi pi-search"></i>
                            <span>그룹별 권한(-)</span>
                        </template>
                        <DataTable :value="programAuthList5" dataKey="authSerl" :scrollable="true" scrollHeight="400px"
                            selectionMode="multiple" :metaKeySelection="false"  responsiveLayout="scroll">
                            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                            <Column field="groupSeq" header="그룹Seq" :sortable="true"></Column>
                            <Column field="useYn" header="사용">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="useYn" :value="data.useYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="newYn" header="신규">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="newYn" :value="data.newYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="retrieveYn" header="조회">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="retrieveYn" :value="data.retrieveYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="saveYn" header="저장">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="saveYn" :value="data.saveYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="saveasYn" header="복사">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="saveasYn" :value="data.saveasYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="cutYn" header="행삭제">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="cutYn" :value="data.cutYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="delYn" header="삭제">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="delYn" :value="data.delYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="printYn" header="출력">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="printYn" :value="data.printYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="excelYn" header="엑셀">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="excelYn" :value="data.excelYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="allYn" header="전체">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="allYn" :value="data.allYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>
                            <Column field="excludeYn" header="권한제외">
                                <template #body="{data, field}">
                                    <Checkbox v-model="data[field]" :binary="true" :readonly="true" />
                                </template>
                                <template #editor="{ data, field }">
                                    <Checkbox :inputId="data.authSerl" name="excludeYn" :value="data.excludeYn" v-model="data[field]" :binary="true"/>
                                </template>
                            </Column>                            
                        </DataTable>
                    </TabPanel>
                </TabView>
                <!--
                <DataTable id="dt2" ref="dt2" :value="minorCodes" dataKey="minorSeq" 
                    selectionMode="multiple" v-model:selection="programAuthList" :scrollable="true" scrollHeight="800px"
                    editMode="row" v-model:editingRows="editingRows2" 
                    @rowEditInit="onRowEditInit2"  @rowEditCancel="onRowEditCancel2" @rowEditSave="onRowEditSave2"
                    class="p-datatable-sm"  responsiveLayout="scroll">
                    <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false"></Column>
                    <Column field="minorSeq" header="소분류코드" :sortable="true"></Column>
                    <Column field="minorNm" header="소분류명" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="20" style="min-width:8em; max-width:8em"/>
                        </template>
                    </Column>
                    <Column field="delimiter" header="구분문자" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="10" style="min-width:6em; max-width:6em"/>
                        </template>
                    </Column>
                    <Column field="sortOrd" header="정렬순서" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputNumber v-model="data[field]" :min="0" integeronly showButtons="true" inputStyle="width:3em"/>
                        </template>
                    </Column>
                    <Column field="useYn" header="사용여부" :sortable="true">
                        <template #body="slotProps">
                            <span>{{slotProps.data.useYn == 1 ? "Y":"N"}}</span>
                        </template>
                        <template #editor="{ data, field }">
                            <Dropdown v-model="data[field]" :options="yns" optionLabel="codeNm" optionValue="code" />
                        </template>
                    </Column>
                    <Column field="defaultYn" header="기본값" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputNumber v-model="data[field]" :min="0" integeronly showButtons="true" inputStyle="width: 4em"/>
                        </template>
                    </Column>
                    <Column field="remark" header="비고" :sortable="true">
                        <template #editor="{ data, field }">
                            <InputText v-model="data[field]" maxLength="100" style="width:10em;"/>
                        </template>
                    </Column>
                    <Column :rowEditor="true" style="min-width:5rem" bodyStyle="text-align:center"></Column>
                    <Column :exportable="false">
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-warning" @click="rowBtnAct('DELETE',slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>
                -->
            </SplitterPanel>
        </Splitter>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import CodeService from '@/service/cm/CodeService';
import ProgramService from '@/service/cm/ProgramService';
import ProgramAuthService from '@/service/cm/ProgramAuthService';
import JsUtils from '@/utilities/JsUtils';


export default {
    setup() {
        onMounted(() => {
            searchParams.compSeq = 1;
            codeService.getEnvCodeList({ compSeq:1, upCode:'bizdiv'}).then(data=> moduleTypes.value = data);  // 모듈(업무구분) 코드
            codeService.getEnvCodeList({ compSeq:1, upCode:'_usertype'}).then(data=> userTypeCodes.value = data);  // 사용자구분 코드

            searchProgramList();            
        })
        const codeService = new CodeService();
		const programService = new ProgramService();
        const programAuthService = new ProgramAuthService();
        const searchParams = reactive({compSeq:null,moduleType:null,pgmNm:null,useYn:null});
        const toast = useToast();
        const confirm = useConfirm();
        const programList = ref([]);
		const selectedProgram = ref({});
        const minorCodes = ref([]);
		const programAuthList = ref([]);    // 사용자별권한 목록
        const programAuthList2 = ref([]);   // 센터별권한 목록
        const selectedProgramAuth = ref({}); // 선택된 행의 사용자권한
        const moduleTypes = ref([]);
        const userTypeCodes = ref([]);
        const editingRows = ref([]);
        const editingRows1 = ref([]);
        const editingRows2 = ref([]);
        const originalRows = ref({});
        const originalRows1 = ref({});
        const originalRows2 = ref({});
        const compCodes = ref([
            {codeNm: '경남도청', code: 1},
        ]);
        const screenCodes = ref([
            {codeNm: '소분류', code: 1},
            {codeNm: '타이틀', code: 2}
        ]);
        const yns = ref([
            {codeNm: '사용', code: '1'},
            {codeNm: '안함', code: '0'}
        ]);
        const dt = ref(); // 데이터 데이블  ref 

        const menu = ref();
		const items = ref([
			{
                label:'추가',
                icon:'pi pi-plus',
                command: () => {
                    // event.originalEvent: Browser event
                    // event.item: Menuitem instance

                    // 한번에 하나의 row만 편집 가능하게 한다
                    if(editingRows1.value.length > 0) {
                        return;
                    }

                    // 목록의 제일 뒤에 추가한다
                    //programAuthList.value.push({});

                    // 목록의 첫번째 행에 추가한다
                    //programAuthList.value.unshift({useYn: true});
                    programAuthList.value.unshift({});

                    // 편집 모드로 행을 추가하여 표시한다
                    editingRows1.value = [...editingRows.value, {}];
                }
			},
			{
                label:'삭제',
                icon:'pi pi-minus',
                command: (event) => {
                    // event.originalEvent: Browser event
                    // event.item: Menuitem instance
                    alert('event = ' + JSON.stringify(event));
                }
			}
		]);

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                    searchProgramList();
                    break;
                case "NEW":
                    // 이미 편집중인 row가 있으면 취소한다 - 한번에 하나의 row만 편집 가능하게 한다
                    if(editingRows.value.length > 0) {
                        return;
                    }

                    // 현재 목록의 첫번째 row에 신규 행을 추가한다
                    programList.value.unshift({compSeq:searchParams.compSeq});
                    // 목록의 첫번째 row를 편집 상태로 변경한다
                    editingRows.value = [...editingRows.value, programList.value[0]];                    
                    break;
                default:
                        break;
            }
        }

        const rowBtnAct = (_act, program)=>
        {
            switch(_act)
            {
                case "DELETE":
                    confirmDeleteOne(program);
                    break;
                default:
                    break;
            }
        }

        /**
         * 프로그램 목록을 조회한다
         */
        const searchProgramList = () => {
            programList.value = [];
            programAuthList.value = [];
            editingRows.value = [];

            programService.getList(searchParams).then(data => {
                //alert('data = ' + JSON.stringify(data));
                programList.value = data;

                programList.value.forEach(row => {
                    //row.excelYn2 = row.excelYn == 1 ? true : false;  // 자바 도메인 클래스(ProgramAuth)에 excelYn2 추가 필요
                    row.useYn = row.useYn == 1 ? true : false;
                    row.newYn = row.newYn == 1 ? true : false;
                    row.retrieveYn = row.retrieveYn == 1 ? true : false;
                    row.saveYn = row.saveYn == 1 ? true : false;
                    row.saveasYn = row.saveasYn == 1 ? true : false;
                    row.cutYn = row.cutYn == 1 ? true : false;
                    row.delYn = row.delYn == 1 ? true : false;
                    row.excelYn = row.excelYn == 1 ? true : false;
                    row.eachCompYn = row.eachCompYn == 1 ? true : false;
                });
            });
			return;
        };

        /**
         * 프로그램 행 수정 시작 시
         */
        const onRowEditInit = (event) =>{
            // 한번에 하나의 row만 편집 가능하게 한다
            if(editingRows.value.length > 1) {
                // 목록에서 마지막으로 선택한 행이 배열에서 마지막에 추가되므로 마지막으로 추가된 항목을 삭제한다
                editingRows.value.pop();
                return;
            }

            originalRows.value[event.index] = {...programList.value[event.index]};
        }

        /**
         * 프로그램 행 수정 취소 시
         */
        const onRowEditCancel = (event) => {
            let {newData} = event;
            if(newData == null || newData.pgmSeq == null) {  // 화면에서 신규 추가한 경우
                programList.value.shift(); // 배열의 맨 앞의 항목을 제거한다.
                editingRows.value = [];
                return;
            }

            programList.value[event.index] = originalRows.value[event.index];
        }

        /**
         * 하나의 프로그램 저장 시
         */
        const onRowEditSave = (event) =>{
            let {newData, index} = event;

            if(!JsUtils.checkUndefineColumns(newData,["compSeq","pgmId","pgmNm"])){
                // 현재 수정중인 row를 편집 상태로 변경한다
                editingRows.value = [...editingRows.value, newData];    
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'법인코드, 프로그램ID, 프로그램명은 필수입력 항목입니다', life:2000});
                return;
            }

            let _data = JSON.parse(JSON.stringify(newData));

            _data.useYn = newData.useYn == true ? 1 : 0;
            _data.newYn = newData.newYn == true ? 1 : 0;
            _data.retrieveYn = newData.retrieveYn == true ? 1 : 0;
            _data.saveYn = newData.saveYn == true ? 1 : 0;
            _data.saveasYn = newData.saveasYn == true ? 1 : 0;
            _data.cutYn = newData.cutYn == true ? 1 : 0;
            _data.delYn = newData.delYn == true ? 1 : 0;
            _data.excelYn = newData.excelYn == true ? 1 : 0;
            _data.eachCompYn = newData.eachCompYn == true ? 1 : 0;

            if(_data.pgmSeq == null) {
                programService.insertOne(_data).then(() => {                    
                    toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});
                    btnAct('SEARCH');
                });
            } else {
                programService.updateOne(_data).then(() => {
                    programList.value[index] = newData;
                    toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                });
            }
        }

        /**
         * 하나의 프로그램 삭제 시
         */
        const confirmDeleteOne = (program) =>{
            confirm.require({
                message:`프로그램(${program.pgmNm})를 삭제하시겠습니까?`,
                header: '프로그램 삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteOne(program);
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteOne = (program) => {
            programService.deleteOne(program.compSeq, program.pgmSeq)
                .then(() => {                    
                    toast.add({severity:'success', summary: '성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };

        
        /**
         * (선택된 프로그램에 대한) 사용자구분별권한/센터별권한 목록을 조회한다
         */
        const onRowSelect = (event) => {
            selectedProgram.value = event.data;
            programAuthList.value = [];

            var _params1 = {compSeq:event.data.compSeq, pgmSeq:event.data.pgmSeq, authGbn:"_usertype"};
            var _params2 = {compSeq:event.data.compSeq, pgmSeq:event.data.pgmSeq, authGbn:"company"};

            // 사용자별권한 목록을 조회한다
            programAuthService.getList(_params1).then(data => {
                programAuthList.value = data;

                programAuthList.value.forEach(row => {
                    //row.excelYn2 = row.excelYn == 1 ? true : false;  // 자바 도메인 클래스(ProgramAuth)에 excelYn2 추가 필요
                    row.useYn = row.useYn == 1 ? true : false;
                    row.newYn = row.newYn == 1 ? true : false;
                    row.retrieveYn = row.retrieveYn == 1 ? true : false;
                    row.saveYn = row.saveYn == 1 ? true : false;
                    row.saveasYn = row.saveasYn == 1 ? true : false;
                    row.cutYn = row.cutYn == 1 ? true : false;
                    row.delYn = row.delYn == 1 ? true : false;
                    row.excelYn = row.excelYn == 1 ? true : false;
                });
            });

            // 센터별권한 목록을 조회한다
            programAuthService.getList2(_params2).then(data => {
                programAuthList2.value = data;

                programAuthList2.value.forEach(row => {
                    row.useYn = row.useYn == 1 ? true : false;
                    row.newYn = row.newYn == 1 ? true : false;
                    row.retrieveYn = row.retrieveYn == 1 ? true : false;
                    row.saveYn = row.saveYn == 1 ? true : false;
                    row.saveasYn = row.saveasYn == 1 ? true : false;
                    row.cutYn = row.cutYn == 1 ? true : false;
                    row.delYn = row.delYn == 1 ? true : false;
                    row.excelYn = row.excelYn == 1 ? true : false;
                });
            });
        };

        /**
         * 사용자구분별권한 탭 목록에서 체크 박스 클릭 시
         */
        const onClickCheckbox1 = (data, field) => {
            switch (field) {
                case "useYn":
                case "newYn":
                case "retrieveYn":
                case "saveYn":
                case "saveasYn":
                case "cutYn":
                case "delYn":
                case "excelYn": {
                        data[field] = !data[field];  // newValue은 undefinded 임.
                        let _newData = deepCopy(data);

                        _newData.useYn = data.useYn == true ? 1 : 0;
                        _newData.newYn = data.newYn == true ? 1 : 0;
                        _newData.retrieveYn = data.retrieveYn == true ? 1 : 0;
                        _newData.saveYn = data.saveYn == true ? 1 : 0;
                        _newData.saveasYn = data.saveasYn == true ? 1 : 0;
                        _newData.cutYn = data.cutYn == true ? 1 : 0;
                        _newData.delYn = data.delYn == true ? 1 : 0;
                        _newData.excelYn = data.excelYn == true ? 1 : 0;

                        if(data.pgmSeq == null) {
                            programAuthService.insertOne(_newData).then(() => {                    
                                toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});

                                // 사용자별권한 목록을 조회한다
                                programAuthService.getList(selectedProgram.value).then(data => {
                                    programAuthList.value = data;
                                });
                            });
                        } else {
                            programAuthService.updateOne(_newData).then(() => {
                                //toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                            });
                        }
                    }
                    break;
                default:
                    break;
            }
        }

        /**
         * 사용자구분별권한 탭 목록에서 체크 박스 셀 편집 시작 시 
         * - 최초 한번 또는 다른 행의 체크박스 클릭 시에는 바로 동작하나, 
         *   같은 행의 다른 체크박스 클릭 시에는 CellEditComplete가 동작하여 두 번 클릭해주어야 하는 문제가 발생한다
         */
        /*
        const onCellEditInit1 = (event) => {
            let { data, field } = event;

            switch (field) {
                case "useYn":
                case "newYn":
                case "retrieveYn":
                case "saveYn":
                case "saveasYn":
                case "cutYn":
                case "delYn":
                case "excelYn": {
                        data[field] = !data[field];  // newValue은 undefinded 임.
                        let _newData = deepCopy(data);

                        _newData.useYn = data.useYn == true ? 1 : 0;
                        _newData.newYn = data.newYn == true ? 1 : 0;
                        _newData.retrieveYn = data.retrieveYn == true ? 1 : 0;
                        _newData.saveYn = data.saveYn == true ? 1 : 0;
                        _newData.saveasYn = data.saveasYn == true ? 1 : 0;
                        _newData.cutYn = data.cutYn == true ? 1 : 0;
                        _newData.delYn = data.delYn == true ? 1 : 0;
                        _newData.excelYn = data.excelYn == true ? 1 : 0;

                        if(data.pgmSeq == null) {
                            programAuthService.insertOne(_newData).then(() => {                    
                                toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});

                                // 사용자별권한 목록을 조회한다
                                programAuthService.getList(selectedProgram.value).then(data => {
                                    programAuthList.value = data;

                                    programAuthList.value.forEach(row => {
                                        row.useYn = row.useYn == 1 ? true : false;
                                        row.newYn = row.newYn == 1 ? true : false;
                                        row.retrieveYn = row.retrieveYn == 1 ? true : false;
                                        row.saveYn = row.saveYn == 1 ? true : false;
                                        row.saveasYn = row.saveasYn == 1 ? true : false;
                                        row.cutYn = row.cutYn == 1 ? true : false;
                                        row.delYn = row.delYn == 1 ? true : false;
                                        row.excelYn = row.excelYn == 1 ? true : false;
                                    });
                                });
                            });
                        } else {
                            programAuthService.updateOne(_newData).then(() => {
                                //toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                            });
                        }
                    }
                    break;
                default:
                    break;
            }

            // 어떤 이벤트를 명시적으로 처리하지 않은 경우, 해당 이벤트에 대한 사용자 에이전트의 기본 동작을 실행하지 않도록 지정한다
            //event.preventDefault();
            // 상위 엘리먼트들로의 이벤트 전파를 중단시킨다
            //event.stopPropagation();
        };
        */

        /**
         * 센터별권한 탭 목록에서 체크 박스 클릭 시
         */
        const onClickCheckbox2 = (data, field) => {
            switch (field) {
                case "useYn":
                case "newYn":
                case "retrieveYn":
                case "saveYn":
                case "saveasYn":
                case "cutYn":
                case "delYn":
                case "excelYn": {
                        data[field] = !data[field];  // newValue은 undefinded 임.
                        let _newData = deepCopy(data);

                        _newData.useYn = data.useYn == true ? 1 : 0;
                        _newData.newYn = data.newYn == true ? 1 : 0;
                        _newData.retrieveYn = data.retrieveYn == true ? 1 : 0;
                        _newData.saveYn = data.saveYn == true ? 1 : 0;
                        _newData.saveasYn = data.saveasYn == true ? 1 : 0;
                        _newData.cutYn = data.cutYn == true ? 1 : 0;
                        _newData.delYn = data.delYn == true ? 1 : 0;
                        _newData.excelYn = data.excelYn == true ? 1 : 0;

                        if(data.pgmSeq == null) {
                            programAuthService.insertOne(_newData).then(() => {                    
                                toast.add({severity:'success', summary: '완료', detail: '등록 완료', life: 3000});

                                // 사용자별권한 목록을 조회한다
                                programAuthService.getList2(selectedProgram.value).then(data => {
                                    programAuthList2.value = data;

                                    programAuthList2.value.forEach(row => {
                                        row.useYn = row.useYn == 1 ? true : false;
                                        row.newYn = row.newYn == 1 ? true : false;
                                        row.retrieveYn = row.retrieveYn == 1 ? true : false;
                                        row.saveYn = row.saveYn == 1 ? true : false;
                                        row.saveasYn = row.saveasYn == 1 ? true : false;
                                        row.cutYn = row.cutYn == 1 ? true : false;
                                        row.delYn = row.delYn == 1 ? true : false;
                                        row.excelYn = row.excelYn == 1 ? true : false;
                                    });
                                });
                            });
                        } else {
                            programAuthService.updateOne(_newData).then(() => {
                                //toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                            });
                        }
                    }
                    break;
                default:
                    break;
            }
        }

        const onUserRightClick = (event) => {
			menu.value.show(event);
		};

        /**깊은 복사
         * @param {ArrayObject} arrayObject
         * ex) [{...}, {...}, ...]
         */
        const deepCopy = (arrayObject) => {
            return JSON.parse(JSON.stringify(arrayObject));
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, programList.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(programList.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        // watch(()=>selectedProgram.value,
        // (meta)=>{
        //     minorCodes.value = [];
        //     if(meta.majorSeq)
        //     {
        //         programAuthService.getList({compSeq: selectedProgram.value.compSeq, majorSeq:meta.majorSeq}).then(data=> minorCodes.value = data);
        //         //programAuthService.getList(selectedProgram.value).then(data=>minorCodes.value = data);
        //     }
        // })

        return { 
            dt, minorCodes, searchParams, screenCodes, compCodes, yns, userTypeCodes, 
            programList, selectedProgram, selectedProgramAuth, programAuthList, programAuthList2, moduleTypes, 
            onRowSelect, btnAct,  rowBtnAct, 
            editingRows, originalRows, editingRows1, originalRows1, editingRows2, originalRows2, 
            onRowEditInit, onRowEditCancel, onRowEditSave, confirmDeleteOne, deleteOne, 
            onClickCheckbox1, onClickCheckbox2, 
            menu, items, onUserRightClick, deepCopy, 
            downloadExcel, exportCSV, 
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.code-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .code-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
